var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1765.3333 1330.6667",
    height: 1330.6667,
    width: 1765.3333,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1330.6667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 13240,0.0117188 H 10.3945 V 9980.01 H 13240 V 0.0117188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10416.7,1747.26 c 410.8,672.71 647.5,1463.25 647.5,2309.13 0,2450.68 -1986.65,4437.36 -4437.34,4437.36 -2450.68,0 -4437.36,-1986.68 -4437.36,-4437.36 0,-845.88 236.77,-1636.42 647.53,-2309.13 h 7579.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10302.4,6745.74 c 3.8,340.8 -435.42,478.85 -628.5,200.59 -26.35,17.14 -55.63,30.01 -86.91,38.04 -48.35,209.9 -236.24,366.46 -460.82,366.46 -234.7,0 -429.36,-170.96 -466.53,-395.12 -263.1,149.01 -554.28,-153.09 -395.49,-410.58 h 2309.05 c 38,158.21 -132.9,281.91 -270.8,200.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3671.89,5032.92 c -17.4,107.72 -110.78,190 -223.42,190 -18.88,0 -37.21,-2.35 -54.75,-6.71 -46.2,109.7 -154.7,186.71 -281.2,186.71 -168.44,0 -305,-136.55 -305,-305 0,-22.31 2.46,-44.05 7.01,-65 h 857.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#c7e9fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4541.62,3717.09 -724.47,955.65 -725.03,-955.65 h -103.74 v -99.3 h 44.74 V 3476.85 H 2770.29 V 1787.36 h 1719.37 c 0,0.25 112.57,0.25 112.57,0.25 v 3.53 h 506.4 v 1925.95 h -567.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#c7e9fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9884.28,3479.61 v 1270.94 h -111.74 v -96.57 h -334.55 v 104.91 h 24.14 v 91.3 h -224.15 v -91.3 h 25.24 V 4653.98 H 8114.13 v 96.57 H 8002.39 V 3479.61 H 7125.3 v 522.11 h 36.55 v 51.04 h -36.55 v 270.1 c 0,77.67 -118.15,78.76 -118.15,-0.52 l -778.11,306.81 -799.17,-308.05 v 5.02 c 0,32.63 -26.44,59.08 -59.07,59.08 -32.63,0 -59.07,-26.45 -59.07,-59.08 v -78.89 c -0.04,0 -0.04,-194.47 -0.04,-194.47 h -38.65 v -51.04 h 38.65 V 3719.84 H 5082.71 V 1793.91 h 666.77 c 0,0.29 2252.91,0.29 2252.91,0.29 v -10.08 h 111.74 v 3.34 h 1670.66 v 1.05 h 99.49 v 5.69 h 418.02 v 1685.41 h -418.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8877.16,3592.62 h -215.87 v 539.35 h 215.87 v -539.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8877.16,2682.43 h -215.87 v 539.36 h 215.87 v -539.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9317.16,2682.43 h -215.87 v 539.36 h 215.87 v -539.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9757.16,2682.43 h -215.87 v 539.36 h 215.87 v -539.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#e5f7fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9317.16,3592.62 h -215.87 v 539.35 h 215.87 v -539.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#8fd9f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3196.82,3964.18 c 16.04,210.53 191.83,376.41 406.46,376.41 214.02,0 389.41,-164.92 406.33,-374.59 149.2,-60.6 254.44,-206.91 254.44,-377.87 0,-225.21 -182.57,-407.77 -407.79,-407.77 -94.58,0 -181.57,32.28 -250.75,86.32 -69.17,-54.04 -156.16,-86.32 -250.74,-86.32 -225.22,0 -407.79,182.56 -407.79,407.77 0,169.22 103.06,314.34 249.84,376.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3228.63,3803.7 c -59.11,-47.56 -69.39,-139.05 -22.96,-204.36 l 214.06,172.23 c -46.43,65.29 -131.99,79.68 -191.1,32.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9545.03,1780.61 h 288.33 l -40.68,113.36 h -206.97 l -40.68,-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9626.55,1893.97 h 126.81 v 792.17 h -126.81 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9545.03,1780.61 h 288.33 l -40.68,113.36 h -206.97 l -40.68,-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10452.6,1893.97 h 70.2 v 792.17 h -70.2 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9695.85,1893.97 h 70.29 v 792.17 h -70.29 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10475.6,1775.81 h 109.5 l -25.4,118.16 h -104.1 l 20,-118.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9721.42,1775.81 h 109.43 l -25.4,118.16 h -104.03 l 20,-118.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2511.07,1780.61 h 288.32 l -40.68,113.36 h -206.96 l -40.68,-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2592.58,1893.97 h 126.81 v 792.17 h -126.81 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2511.07,1780.61 h 288.32 l -40.68,113.36 h -206.96 l -40.68,-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3418.58,1893.97 h 70.29 v 792.17 h -70.29 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2661.89,1893.97 h 70.28 v 792.17 h -70.28 v -792.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3441.67,1775.81 h 109.44 l -25.4,118.16 h -104.04 l 20,-118.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2687.45,1775.81 h 109.43 l -25.39,118.16 h -104.04 l 20,-118.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11632,1870.96 h -227 v 136.99 c 0,13.25 14.9,23.95 33.3,23.95 h 160.4 c 18.4,0 33.3,-10.7 33.3,-23.95 v -136.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11673.1,3860.53 h -320.7 v 60.33 h 320.7 v -60.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1861.78,1870.96 h -227.06 v 136.99 c 0,13.25 14.91,23.95 33.31,23.95 h 160.44 c 18.39,0 33.31,-10.7 33.31,-23.95 v -136.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1902.82,3860.53 h -320.67 v 60.33 h 320.67 v -60.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 5360.72,6433.6 c -22.59,126.33 -20.36,117.13 -21.86,117.34 -0.15,0.51 -0.26,0.84 -0.32,0.88 -1.15,5.8 -16.67,84.55 -16.04,81.33 l 61.78,86.99 59.25,83.4 c 52.75,72.81 105.76,144.75 156.05,222.32 z m -170.8,-0.02 -238.87,592.28 c 50.58,-78 106.87,-154.45 156.06,-222.32 l 59.24,-83.4 61.77,-86.97 -16.04,-81.35 c -1.59,-0.02 0.2,6.9 -22.16,-118.24 z m 113.06,223.18 c -0.41,24.4 0.9,16.06 -2.83,19.55 -65.65,0.02 -51.23,6.25 -52.91,-19.8 -9.83,-0.26 -13.92,1.07 -15.36,-4.51 -0.28,-1.21 -2.98,-14.91 -2.75,-13.73 l -58.15,81.87 c 72.31,0 136.38,0 208.67,0 l -58.15,-81.89 c -3.81,18.65 -0.15,18.45 -18.52,18.51 z m 29.93,-104.9 c -73.73,0.04 -69.28,0.2 -115.19,0.02 l 13.2,66.97 c 7.33,-1.21 87.63,-0.23 88.83,-0.21 z m -51.48,1229.75 c -3.66,0.45 -7.34,0.39 -11.02,0.02 -332.48,-2.23 -500.27,-202.19 -461.69,-445.47 14.22,-89.59 67.27,-192.35 131.41,-293.3 l 248.83,-616.98 1.12,0.45 c 5.05,-0.52 24.21,-0.82 48.05,-0.95 12.53,-0.04 -45.4,-0.04 122.57,-0.04 0.58,0.21 0.84,0.37 1.01,0.64 328.09,788.52 200.09,530.82 283.38,673.48 90.42,154.88 94.38,229.45 96.82,236.76 37.53,236.79 -121.04,442.55 -460.48,445.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8527.17,2311.61 H 8406.2 l -37.67,2119.06 v 23.01 h 123.48 v 151.83 h 91.91 v 100.69 h -91.91 v 196.87 h 65.58 v 100.7 h -65.58 v 304.28 h 27.7 v -56.89 h 151.86 l 0.02,166.25 c -0.01,0 -0.01,49.76 -0.01,49.76 l 133.76,-54.2 93.88,128.46 -2369.26,996.02 -2357.15,-975.14 97.42,-131.99 112.05,44.7 v -2.75 -150.37 -70.35 h 151.43 l 0.01,56.89 145.88,-0.02 -123.12,13.03 -13.05,-317.68 h -58.34 v -100.7 h 58.34 V 4706.2 h -58.34 v -100.69 h 84.42 v -151.83 h 130.14 v -39.03 l -37.37,-2103.04 h -60.97 -41.61 -414.48 v -80.96 h 41.61 V 1756 h 163.54 209.33 3967.47 242.85 129.2 v 474.65 h 50.25 v 80.96 h -422.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6559.9,6331.82 -2171.58,-852.89 27.42,-69.82 2171.57,852.91 -27.41,69.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6517.86,6321.82 2171.57,-852.89 -27.41,-69.82 -2171.58,852.91 27.42,69.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5992.17,4833.4 H 4558.43 v 69.67 h 1433.74 v -69.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8490.91,4833.4 H 7057.17 v 69.67 h 1433.74 v -69.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5238.63,4540.06 h -152.12 v 65.45 h 152.12 v -65.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7984.49,4540.06 h -152.12 v 65.45 h 152.12 v -65.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#8fd9f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6500.44,3672 h -460.53 v 692.03 h 460.53 V 3672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#8fd9f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7048.78,3672 h -460.52 v 692.03 h 460.52 V 3672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5377.75,3672 h -409.11 v 631.4 h 409.11 V 3672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5352.66,2690.06 h -358.67 v 617.44 h 358.67 v -617.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8112.99,3672 h -409.12 v 631.4 h 409.12 V 3672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8087.89,2690.06 h -358.66 v 617.44 h 358.66 v -617.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7031.76,2230.65 h -965.84 v 1215.02 h 965.84 V 2230.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4963.88,4406.74 h -254.33 v 66.66 h 254.33 v -66.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5635.19,4406.74 h -254.31 v 66.66 h 254.31 v -66.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7692.18,4406.74 h -254.32 v 66.66 h 254.32 v -66.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8374.49,4406.74 h -254.33 v 66.66 h 254.33 v -66.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5380.88,4230.94 h -412.24 v 72.46 h 412.24 v -72.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5370.09,3235.04 h -390.67 v 72.46 h 390.67 v -72.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8124.31,4230.94 h -412.24 v 72.46 h 412.24 v -72.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8103.22,3235.04 h -391.15 v 72.46 h 391.15 v -72.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7314.74,3987.7 H 5761.93 v 585.08 H 7314.74 V 3987.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#62bee4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7437.02,3987.7 H 5635.19 v 452.36 H 7437.02 V 3987.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7314.74,4540.06 H 5761.93 v 65.45 h 1552.81 v -65.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7045.02,3370.06 h -959.93 v 88.5 h 959.93 v -88.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6958.43,3458.56 h 73.33 V 2230.65 h -73.33 v 1227.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6065.92,3458.56 h 73.34 V 2230.65 h -73.34 v 1227.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4578.72,2170.06 h -391.89 v 60.59 h 391.89 v -60.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8899.22,2156.06 h -364.13 v 67.34 h 364.13 v -67.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,2793.4 668.35,668.34 h -99.19 l -569.16,-569.16 v -99.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,2258.52 v -11.7 h 87.48 l 887.47,887.46 v 99.18 l -974.95,-974.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,2469.91 v -99.2 l 974.95,974.94 v 99.2 l -974.95,-974.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,2582.06 879.69,879.68 h -99.18 l -780.51,-780.5 v -99.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,3004.75 457,456.99 h -99.18 l -357.82,-357.81 v -99.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,3216.1 245.65,245.64 h -99.19 L 6067.41,3315.3 v -99.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6067.41,3461.74 v -34.29 l 34.3,34.29 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6366.24,2246.82 676.12,676.11 v 99.18 l -775.3,-775.29 h 99.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7000.28,2246.82 42.08,42.07 v 99.18 L 6901.1,2246.82 h 99.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6577.59,2246.82 464.77,464.77 v 99.18 L 6478.4,2246.82 h 99.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#4b9dc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6788.93,2246.82 253.43,253.42 v 99.18 l -352.62,-352.6 h 99.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3610.42,1781.97 h -35 v 1652.48 h 35 V 1781.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3579.72,3024.14 -281.61,323.96 26.42,22.97 281.6,-323.97 -26.41,-22.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3604.4,2834.16 -22.95,26.42 158.02,137.27 22.95,-26.43 -158.02,-137.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3592.92,3288.88 10.78,-8.42 c 69.18,-54.04 152.16,-82.61 239.98,-82.61 215.2,0 390.28,175.07 390.28,390.29 0,159.59 -95.59,301.54 -243.53,361.66 l -9.99,4.04 -0.86,10.76 c -16.23,201.02 -187.04,358.48 -388.89,358.48 -202.74,0 -373.62,-158.22 -389.02,-360.21 l -0.81,-10.67 -9.86,-4.14 c -145.25,-61.09 -239.11,-202.36 -239.11,-359.92 0,-215.22 175.08,-390.29 390.29,-390.29 87.8,0 170.78,28.57 239.97,82.61 z m 250.76,-126.03 c -91.19,0 -177.59,28.26 -250.76,81.89 -73.17,-53.63 -159.57,-81.89 -250.74,-81.89 -234.51,0 -425.29,190.78 -425.29,425.29 0,168.14 98.09,319.26 250.82,387.95 21.83,215.06 205.6,381.99 422.98,381.99 216.37,0 400.02,-166.07 422.78,-380.02 155.56,-67.69 255.49,-219.59 255.49,-389.92 0,-234.51 -190.78,-425.29 -425.28,-425.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11438.8,3629.19 h 148.5 l 75.2,240.67 1,33.49 h -305.9 v -33.55 z m 174.2,-35 h -199.3 l -91.1,269.87 v 74.29 h 377 l -2.3,-74.35 -84.3,-269.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11530.7,2169.47 h -35 v 1339.12 h 35 V 2169.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11597.6,2105.85 h -35 v 27.06 c 0,2.53 -2.1,4.6 -4.6,4.6 h -86.5 c -2.5,0 -4.6,-2.07 -4.6,-4.6 v -27.06 h -35 v 27.06 c 0,21.83 17.8,39.6 39.6,39.6 h 86.5 c 21.8,0 39.6,-17.77 39.6,-39.6 v -27.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11649.4,1880.13 h -35 v 128.44 c 0,7.6 -6.2,13.79 -13.8,13.79 h -167 c -7.6,0 -13.8,-6.19 -13.8,-13.79 v -128.44 h -35 v 128.44 c 0,26.89 21.9,48.79 48.8,48.79 h 167 c 26.9,0 48.8,-21.9 48.8,-48.79 v -128.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11785,1768.35 h -35 v 66.98 c 0,10.76 -8.8,19.51 -19.5,19.51 h -422.4 c -10.8,0 -19.5,-8.75 -19.5,-19.51 v -61.66 h -35 v 61.66 c 0,30.06 24.4,54.51 54.5,54.51 h 422.4 c 30,0 54.5,-24.45 54.5,-54.51 v -66.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11441.2,3629.19 h 148.5 l 75.2,240.67 1,33.49 H 11360 v -33.55 z m 174.2,-35 h -199.3 l -91.1,269.87 v 74.29 h 377 l -2.3,-74.35 -84.3,-269.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11577.6,3075.05 h -124 c -9.7,0 -17.5,7.84 -17.5,17.5 0,9.67 7.8,17.5 17.5,17.5 h 124 c 9.7,0 17.5,-7.83 17.5,-17.5 0,-9.66 -7.8,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11575.2,3493.67 h -124 c -9.7,0 -17.5,7.83 -17.5,17.5 0,9.66 7.8,17.5 17.5,17.5 h 124 c 9.7,0 17.5,-7.84 17.5,-17.5 0,-9.67 -7.8,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11649.7,3594.19 h -272.9 c -9.7,0 -17.5,7.84 -17.5,17.5 0,9.67 7.8,17.5 17.5,17.5 h 272.9 c 9.6,0 17.5,-7.83 17.5,-17.5 0,-9.66 -7.9,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1668.57,3629.19 h 148.44 l 75.2,240.67 1.03,33.49 h -305.93 v -33.55 z m 174.17,-35 h -199.29 l -91.14,269.87 v 74.29 h 377.02 l -2.29,-74.35 -84.3,-269.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1760.44,2169.47 h -35 v 1339.12 h 35 V 2169.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1827.33,2105.85 h -35 v 27.06 c 0,2.53 -2.07,4.6 -4.61,4.6 h -86.45 c -2.54,0 -4.61,-2.07 -4.61,-4.6 v -27.06 h -35 v 27.06 c 0,21.83 17.77,39.6 39.61,39.6 h 86.45 c 21.84,0 39.61,-17.77 39.61,-39.6 v -27.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1879.11,1880.13 h -35 v 128.44 c 0,7.6 -6.18,13.79 -13.77,13.79 h -167 c -7.6,0 -13.78,-6.19 -13.78,-13.79 v -128.44 h -35 v 128.44 c 0,26.89 21.88,48.79 48.78,48.79 h 167 c 26.89,0 48.77,-21.9 48.77,-48.79 v -128.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2014.72,1768.35 h -35 v 66.98 c 0,10.76 -8.75,19.51 -19.51,19.51 h -422.42 c -10.75,0 -19.5,-8.75 -19.5,-19.51 v -61.66 h -35 v 61.66 c 0,30.06 24.45,54.51 54.5,54.51 h 422.42 c 30.06,0 54.51,-24.45 54.51,-54.51 v -66.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1670.96,3629.19 h 148.45 l 75.2,240.67 1.02,33.49 h -305.92 v -33.55 z m 174.18,-35 h -199.3 l -91.13,269.87 v 74.29 h 377.02 l -2.29,-74.35 -84.3,-269.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1807.35,3075.05 h -124.02 c -9.66,0 -17.5,7.84 -17.5,17.5 0,9.67 7.84,17.5 17.5,17.5 h 124.02 c 9.66,0 17.5,-7.83 17.5,-17.5 0,-9.66 -7.84,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1804.95,3493.67 h -124.01 c -9.67,0 -17.5,7.83 -17.5,17.5 0,9.66 7.83,17.5 17.5,17.5 h 124.01 c 9.66,0 17.5,-7.84 17.5,-17.5 0,-9.67 -7.84,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1879.39,3594.19 h -272.9 c -9.66,0 -17.5,7.84 -17.5,17.5 0,9.67 7.84,17.5 17.5,17.5 h 272.9 c 9.67,0 17.5,-7.83 17.5,-17.5 0,-9.66 -7.83,-17.5 -17.5,-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10291.2,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10191.5,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10091.9,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9992.21,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9892.55,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9535.29,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9435.64,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9335.98,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9236.32,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9136.67,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10398.4,1911.58 h 106.9 v 757.05 h -106.9 z m 141.9,-35 h -176.9 v 827.05 h 176.9 v -827.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10335,1789.8 h 235.1 l -23.8,86.68 h -187.5 z m 281,-35 h -326.9 l 43,156.68 h 240.9 l 43,-156.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10362.9,2703.63 h 185.4 v 31.93 h -185.4 z m 220.4,-35 h -255.4 v 101.93 h 255.4 v -101.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10440.4,2829.8 h 30.5 l 15.2,26.41 -15.2,26.38 h -30.5 l -15.2,-26.38 z m 50.7,-35 h -70.9 l -35.5,61.41 35.5,61.38 h 70.9 l 35.4,-61.38 -35.4,-61.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9641.7,1911.58 h 106.94 v 757.05 H 9641.7 Z m 141.94,-35 H 9606.7 v 827.05 h 176.94 v -827.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9578.28,1789.8 h 235.15 l -23.8,86.68 h -187.56 z m 281.04,-35 h -326.94 l 43,156.68 h 240.94 l 43,-156.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9606.23,2703.63 h 185.42 v 31.93 h -185.42 z m 220.42,-35 h -255.42 v 101.93 h 255.42 v -101.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9683.7,2829.8 h 30.48 l 15.24,26.41 -15.24,26.38 h -30.48 l -15.24,-26.38 z m 50.69,-35 h -70.9 l -35.44,61.41 35.44,61.38 h 70.9 l 35.44,-61.38 -35.44,-61.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9625.02,2095.83 h -613.08 v 35 h 613.08 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11043.7,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10944,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10844.4,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10744.7,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10645.1,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11133.4,2095.83 h -613 v 35 h 613 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10372.3,2276.6 h -613.04 v 35 h 613.04 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3257.21,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3157.55,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3057.89,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2958.24,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2858.58,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2501.33,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2401.67,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2302.01,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2202.36,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2102.7,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3364.43,1911.58 h 106.94 v 757.05 h -106.94 z m 141.94,-35 h -176.94 v 827.05 h 176.94 v -827.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3301.01,1789.8 h 235.15 l -23.8,86.68 H 3324.8 Z m 281.04,-35 h -326.94 l 43,156.68 h 240.94 l 43,-156.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3328.96,2703.63 h 185.42 v 31.93 h -185.42 z m 220.42,-35 h -255.42 v 101.93 h 255.42 v -101.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3406.43,2829.8 h 30.48 l 15.24,26.41 -15.24,26.38 h -30.48 l -15.24,-26.38 z m 50.69,-35 h -70.9 l -35.44,61.41 35.44,61.38 h 70.9 l 35.44,-61.38 -35.44,-61.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2607.73,1911.58 h 106.94 v 757.05 h -106.94 z m 141.94,-35 h -176.94 v 827.05 h 176.94 v -827.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2544.32,1789.8 h 235.14 l -23.8,86.68 h -187.55 z m 281.04,-35 h -326.94 l 43,156.68 h 240.93 l 43.01,-156.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2572.26,2703.63 h 185.42 v 31.93 h -185.42 z m 220.42,-35 h -255.42 v 101.93 h 255.42 v -101.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2649.74,2829.8 h 30.47 l 15.24,26.41 -15.24,26.38 h -30.47 l -15.24,-26.38 z m 50.68,-35 h -70.89 l -35.45,61.41 35.45,61.38 h 70.89 l 35.45,-61.38 -35.45,-61.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2591.05,2095.83 h -613.07 v 35 h 613.07 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4009.74,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3910.08,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3810.42,1874.27 h -35 v 778.65 h 35 v -778.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3710.77,1874.27 h -35 v 712.78 h 35 v -712.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3611.11,1874.27 h -35 v 662.11 h 35 v -662.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4099.46,2095.83 h -613.07 v 35 h 613.07 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3338.36,2276.6 h -613.07 v 35 h 613.07 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 12125.9,1753.94 H 1127.81 v 35 H 12125.9 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4560.93,4706.13 h -35 v 196.95 h 35 v -196.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8518.72,4706.13 h -35 v 196.95 h 35 v -196.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8518.72,5003.76 h -35 v 287.17 H 4560.93 v -287.17 h -35 v 322.17 h 3992.79 v -322.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4408.99,5430.48 h 4254.3 v 24.91 L 6542.66,6314.53 4408.99,5463.16 Z m 4289.3,-35 h -4324.3 v 91.39 l 2168.77,865.37 6.52,-2.64 2149.01,-870.64 v -83.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6542.76,6352.24 6.52,-2.64 2259.19,-915.27 72.76,99.55 -2342.11,984.61 -2329.73,-963.79 76.12,-103.12 z m 2277.86,-960.6 -12.65,5.13 -2265.31,917.76 -2269.27,-905.47 -118.74,160.88 2384.58,986.48 6.73,-2.83 2389.67,-1004.61 -115.01,-157.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4586.41,1788.94 h 3932.47 v 424.2 H 4586.41 Z m 3967.47,-35 H 4551.41 v 494.2 h 4002.47 v -494.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5973.35,2256.48 h 75.07 v 1206.7 H 7049.79 V 2258.22 h 73.91 v 1204.96 h 0.92 v 64.59 H 5973.35 Z m 110.07,-35 h -145.07 v 1341.29 h 1221.27 v -134.59 h -0.92 V 2223.22 h -143.91 v 1204.96 h -931.37 v -1206.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4586.41,2098.96 h 3932.47 v 114.18 H 4586.41 Z m 3967.47,-35 H 4551.41 v 184.18 h 4002.47 v -184.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4586.41,1936.23 h 3932.47 v 127.73 H 4586.41 Z m 3967.47,-35 H 4551.41 v 197.73 h 4002.47 v -197.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4586.41,1788.94 h 3932.47 v 112.29 H 4586.41 Z m 3967.47,-35 H 4551.41 v 182.29 h 4002.47 v -182.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8546.42,5268.67 116.86,-0.02 0.02,131.27 -4254.3,0.39 -0.01,-131.25 h 116.44 l 0.01,56.87 h 180.87 v -56.89 l 114.51,-0.02 v 56.89 l 180.88,-0.02 V 5269 h 114.51 v 56.87 h 180.89 l -0.01,-56.89 114.52,-0.02 v 56.89 l 180.88,-0.02 -0.01,-56.89 H 5707 l 0.01,56.88 h 180.87 v -56.9 l 114.51,-0.02 0.01,56.9 180.88,-0.02 v -56.88 l 114.51,-0.02 v 56.9 l 180.88,-0.02 v -56.9 l 114.51,-0.02 v 56.9 l 180.88,-0.02 v -56.88 l 114.51,-0.02 0.01,56.9 180.88,-0.02 -0.01,-56.9 114.52,-0.02 0.01,56.9 h 180.87 v -56.9 l 114.51,-0.02 v 56.9 l 180.88,-0.02 v -56.89 h 114.51 v 56.87 h 180.89 l -0.01,-56.89 114.52,-0.02 v 56.89 l 180.88,-0.02 -0.01,-56.89 h 114.52 l 0.01,56.87 h 180.87 z m 151.86,-35.02 -186.86,0.02 v 56.89 h -110.88 l -0.01,-56.87 h -184.51 l 0.01,56.89 -110.88,0.02 v -56.89 l -184.52,0.02 0.01,56.89 h -110.89 v -56.87 h -184.51 v 56.89 l -110.88,0.02 v -56.9 l -184.51,0.02 v 56.9 h -110.88 l -0.01,-56.9 -184.51,0.02 0.01,56.9 -110.89,0.02 -0.01,-56.9 -184.5,0.02 v 56.88 l -110.88,0.02 v -56.9 l -184.51,0.02 v 56.9 l -110.88,0.02 v -56.9 l -184.51,0.02 v 56.88 l -110.88,0.02 -0.01,-56.9 -184.51,0.02 v 56.9 H 5742 l -0.01,-56.88 h -184.51 l 0.01,56.89 -110.88,0.02 v -56.89 l -184.52,0.02 0.01,56.89 H 5151.21 V 5234 H 4966.7 v 56.89 l -110.88,0.02 v -56.89 l -184.51,0.02 v 56.89 h -110.88 l -0.01,-56.87 h -186.43 l 0.01,201.25 4324.3,-0.39 -0.02,-201.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4502.59,4920.58 h 1472.08 v 65.7 H 4502.59 Z m 1507.08,-35 H 4467.59 v 135.7 h 1542.08 v -135.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4502.59,4623 h 4037.5 v 65.71 h -4037.5 z m 4072.5,-35 h -4107.5 v 135.71 h 4107.5 V 4588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7074.67,4920.58 h 1465.42 v 65.7 H 7074.67 Z m 1500.42,-35 H 7039.67 v 135.7 h 1535.42 v -135.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6057.41,3689.51 h 425.53 v 657.03 h -425.53 z m 460.53,-35 h -495.53 v 727.03 h 495.53 v -727.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5973.35,3689.51 h 1145.76 v 746.68 H 5973.35 Z m 1180.76,-35 H 5938.35 v 816.68 h 1215.76 v -816.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6609.52,3689.51 h 418 v 657.03 h -418 z m 453,-35 h -488 v 727.03 h 488 v -727.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8553.88,1788.94 h 337.05 v 424.2 h -337.05 z m 372.05,-35 h -407.05 v 494.2 h 407.05 v -494.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4213.54,1788.94 h 337.87 v 424.2 h -337.87 z m 372.87,-35 h -407.87 v 494.2 h 407.87 v -494.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7424.14,2329.1 h 295.94 l -39.26,2143.16 h 124.21 V 4588 h -472.79 v -115.74 h 131.16 z m 331.58,-35 H 7388.5 l 39.25,2143.16 H 7297.24 V 4623 h 542.79 v -185.74 h -123.56 l 39.25,-2143.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7322.43,2248.14 h 517.76 v 45.96 h -517.76 z m 552.76,-35 h -587.76 v 115.96 h 587.76 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8102.84,2329.1 h 295.92 l -39.24,2143.16 h 124.2 V 4588 h -472.79 v -115.74 h 131.15 z m 331.57,-35 h -367.22 l 39.25,2143.16 H 7975.93 V 4623 h 542.79 v -185.74 h -123.56 l 39.25,-2143.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8001.12,2248.14 h 517.76 v 45.96 h -517.76 z m 552.76,-35 h -587.76 v 115.96 h 587.76 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5363.55,2329.1 h 295.93 l -39.25,2143.16 h 124.2 V 4588 h -472.79 v -115.74 h 131.16 z m 331.57,-35 H 5327.9 l 39.25,2143.16 H 5236.64 V 4623 h 542.79 v -185.74 h -123.56 l 39.25,-2143.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5261.83,2248.14 h 517.76 v 45.96 h -517.76 z m 552.76,-35 h -587.76 v 115.96 h 587.76 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4688.13,2329.1 h 295.93 l -39.25,2143.16 h 124.2 V 4588 h -472.79 v -115.74 h 131.16 z m 331.58,-35 h -367.23 l 39.25,2143.16 H 4561.22 V 4623 h 542.79 v -185.74 h -123.56 l 39.26,-2143.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4628.02,2248.14 h 476.15 v 45.96 h -476.15 z m 511.15,-35 h -546.15 v 115.96 h 546.15 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8553.88,2248.14 h 387.3 v 45.96 h -387.3 z m 422.3,-35 h -457.3 v 115.96 h 457.3 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4171.93,2248.14 h 421.09 v 45.96 h -421.09 z m 456.09,-35 h -491.09 v 115.96 h 491.09 v -115.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6213.79,4897.75 h 56.82 c 15.2,0 36.86,5.06 36.86,23.65 0,17.7 -21.66,26.99 -36.86,26.99 h -56.82 z m 0,83.26 h 56.82 c 23.36,0 30.95,9.84 30.95,21.11 0,9.01 -7.31,24.2 -30.95,24.2 h -56.82 z m 124.64,21.95 c 0,-15.17 -7.34,-29.8 -25.62,-37.96 23.06,-7.04 31.52,-31.51 31.52,-43.91 0,-43.87 -32.92,-57.95 -73.72,-57.95 -31.23,0 -62.18,0 -93.41,0 v 196.93 c 30.95,0 62.18,0 93.41,0 38.81,0 67.82,-17.42 67.82,-57.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6458.94,5018.73 -36.59,-83.83 h 73.16 z m 51.49,-118.44 h -102.98 l -16.88,-37.15 h -40.24 l 88.35,196.93 h 40.52 l 88.33,-196.93 h -40.5 l -16.6,37.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6713.94,5060.35 h 37.14 v -197.21 h -23.06 c 0,-0.27 -103.53,132.81 -103.53,132.81 v -132.81 h -37.14 v 196.93 h 30.1 l 96.49,-122.11 v 122.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6932.58,5058.96 -87.5,-94.24 94.81,-99.31 v -2.27 h -45.85 l -82.44,87.23 v -87.23 h -37.14 v 196.93 h 37.14 v -83.26 l 74.85,83.26 h 46.13 v -1.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5377.75,4285.89 h -409.11 v 35 h 409.11 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8122.75,4285.89 h -409.11 v 35 h 409.11 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5377.75,3654.51 h -409.11 v 35 h 409.11 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5377.75,3290 h -409.11 v 35 h 409.11 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5352.39,2658.61 h -358.4 v 35 h 358.4 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8103.22,3290 h -389.58 v 35 h 389.58 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8082.59,2658.61 h -368.95 v 35 h 368.95 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8122.75,3654.51 h -409.11 v 35 h 409.11 v -35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "#1c2039",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6570.15,2238.98 h -35 v 1206.7 h 35 v -1206.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b4e2ea5a308e60d7e0788209fe8ff400.svg";
export { ForwardRef as ReactComponent };